module.exports = __webpack_public_path__ + "media/pages/assets/images/instagram-d2ecff769877995aedb251d70d1ab90e.svg";